// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__16jVQ","errorLogs":"EditorFooter_errorLogs__2arXo"};